import React from 'react';
import clsx from 'clsx';

//data
import { SHOPPERS_ECOMM_URL, PHARMA_ECOMM_URL, SDM_LOGO, PHARMA_LOGO } from '../../../data/constants';

//styles
import styles from './condensed-masthead.module.scss';
import Image from 'next/image';

export const CondensedMasthead = ({ isPharmaprix, altText }:{ isPharmaprix: boolean, altText: string}) => {
  return (
    <section className={styles.mastHeadContainer} role="banner" data-testid="condensedMastHeadSection">
      <a
        className={styles.mastheadLink}
        href={isPharmaprix ? PHARMA_ECOMM_URL : SHOPPERS_ECOMM_URL}
        rel="noopener noreferrer"
      >
        <Image 
          src={isPharmaprix ? PHARMA_LOGO : SDM_LOGO}
          alt={''}
          width={100}
          height={24}
          className={clsx({ [styles.shoppersLogo]: !isPharmaprix, [styles.pharmaLogo]: isPharmaprix })}
          aria-label={altText}
        />
      </a>
    </section>
  );
};